import * as React from 'react';
import { ToolbarConfig, OutlineType } from '@tencent/workbench';
import { DropdownType, getFontSizeConfigData } from '@editor/src/js/constants/toolbar-data';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_DROPDOWN } from '@editor/src/img/pageIndex';
import { wrapIdForInput } from '@framework/workbench/util/wrap-id-util';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.FONTSIZE,
    content: i18n.t('字号'),
    value: '',
    tipMsg: i18n.t('字号'),
    icon: null,
    showSelectedValue: true,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.FONT,
        checkSelectedValue: true,
        data: getFontSizeConfigData(),
    },
    twdConfig: {
        action: TDWActionType.FONT_FONT_SIZE,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tipMsg,
        style: {
            width: 46,
        },
    },
    {
        name: wrapIdForInput(config.id),
        text: i18n.t('字号'),
        tooltip: config.tipMsg,
        outlineType: OutlineType.INPUT,
        style: {
            width: 46,
        },
    },
];
